export enum MEDIA_PERMISSIONS {
  MEDIA_VIEW = 'CONTENT_MEDIAVIEW',
  MEDIA_WRITE = 'CONTENT_MEDIAWRITE',
}
